<div class="block--wrap block">
    <footer class="footer">
        <div class="footer__column">
            <img
                class="hide-for-wcag"
                src="{{ assetsPath$ | async }}/logo-footer.png"
                alt="{{ 'LOGO_ARIA_LABEL' | translate }}" />
            <img
                class="show-high-contrast-view"
                src="{{ assetsPath$ | async }}/logo-footer-wcag.png"
                alt="{{ 'LOGO_ARIA_LABEL' | translate }}" />
        </div>

        <div class="footer__column">
            <div class="footer__title">{{ 'FOOTER_SERVICES' | translate }}</div>
            <ul innerHtml="{{ 'FOOTER_SERVICES_ITEMS' | translate }}" ridangoTranslatedLink></ul>
        </div>

        <div class="footer__column">
            <div class="footer__title">{{ 'FOOTER_ACTIONS' | translate }}</div>
            <ul>
                <li class="footer__item" *ngIf="footerActions.includes('purchase-ticket')">
                    <a
                        class="link--no-line"
                        [routerLink]="'/purchase/ticket' | localize"
                        routerLinkActive="router-link-active">
                        {{ 'FOOTER_BUY_PERIOD_TICKET' | translate }}
                    </a>
                </li>

                <li class="footer__item" *ngIf="footerActions.includes('purchase-wallet')">
                    <a
                        class="link--no-line"
                        [routerLink]="'/purchase/wallet' | localize"
                        routerLinkActive="router-link-active">
                        {{ 'FOOTER_LOAD_MONEY' | translate }}
                    </a>
                </li>

                <li class="footer__item" *ngIf="footerActions.includes('book-a-ride')">
                    <a
                        class="link--no-line"
                        [routerLink]="'/book-a-ride' | localize"
                        routerLinkActive="router-link-active">
                        {{ 'FOOTER_BOOK_RIDE' | translate }}
                    </a>
                </li>

                <li class="footer__item" *ngIf="footerActions.includes('personalize')">
                    <a
                        class="link--no-line"
                        [routerLink]="'/personalize' | localize"
                        routerLinkActive="router-link-active">
                        {{ 'FOOTER_PERSONALIZE' | translate }}
                    </a>
                </li>

                <li
                    class="footer__item"
                    *ngIf="
                        footerActions.includes('bankcard-tickets') && helperService.isAllowedPath('/bankcard-tickets')
                    ">
                    <a
                        class="link--no-line"
                        [routerLink]="'/bankcard-tickets' | localize"
                        routerLinkActive="router-link-active">
                        {{ 'FOOTER_BANKCARD_TICKETS' | translate }}
                    </a>
                </li>

                <ng-template [ngIf]="ridangoAuth.getLoginStatus()" [ngIfElse]="authLinks">
                    <li class="footer__item" *ngIf="footerActions.includes('purchase-history')">
                        <a
                            class="link--no-line"
                            [routerLink]="'/account/purchase-history' | localize"
                            routerLinkActive="router-link-active">
                            {{ 'MY_ACCOUNT_PURCHASE_HISTORY' | translate }}
                        </a>
                    </li>

                    <li class="footer__item" *ngIf="footerActions.includes('account-profile')">
                        <a
                            class="link--no-line"
                            [routerLink]="'/account/profile' | localize"
                            routerLinkActive="router-link-active">
                            {{ 'MY_ACCOUNT_PROFILE' | translate }}
                        </a>
                    </li>

                    <li class="footer__item" *ngIf="footerActions.includes('related-cards')">
                        <a
                            class="link--no-line"
                            [routerLink]="'/account/related-cards' | localize"
                            routerLinkActive="router-link-active">
                            {{ 'MY_ACCOUNT_CARDS_ACTIVE_TICKETS' | translate }}
                        </a>
                    </li>
                </ng-template>

                <ng-template #authLinks>
                    <li class="footer__item" *ngIf="footerActions.includes('login')">
                        <a
                            class="link--no-line"
                            [routerLink]="'/login' | localize"
                            routerLinkActive="router-link-active">
                            {{ 'FOOTER_LOG_IN' | translate }}
                        </a>
                    </li>

                    <li class="footer__item" *ngIf="footerActions.includes('register')">
                        <a
                            class="link--no-line"
                            [routerLink]="'/register' | localize"
                            routerLinkActive="router-link-active">
                            {{ 'FOOTER_REGISTER' | translate }}
                        </a>
                    </li>
                </ng-template>
            </ul>
        </div>

        <div class="footer__column footer__column--last">
            <div class="footer__title">{{ 'FOOTER_CUSTOMER_SUPPORT' | translate }}</div>
            <ul>
                <li class="footer__item" *ngIf="footerSupportActions.includes('mail')">
                    <span class="icon icon-mail"></span>
                    <a class="link--no-line" href="{{ 'FOOTER_MAIL_US_LINK' | translate }}">
                        {{ 'FOOTER_MAIL_US' | translate }}
                    </a>
                </li>

                <li class="footer__item" *ngIf="footerSupportActions.includes('phone')">
                    <span class="icon icon-call"></span>
                    <a
                        class="link--no-line"
                        href="{{ 'FOOTER_PHONE_LINK' | translate }}"
                        attr.aria-label="{{ 'FOOTER_CALL_US' | translate }}">
                        {{ 'FOOTER_PHONE_TEXT' | translate }}
                    </a>
                </li>

                <li class="footer__item" *ngIf="footerSupportActions.includes('FAQ')">
                    <span class="icon icon-info"></span>
                    <a
                        class="link--no-line"
                        [href]="!helperService.isAllowedPath('/faq') ? ('FOOTER_FAQ_LINK' | translate) : null"
                        [routerLink]="helperService.isAllowedPath('/faq') ? ('/faq' | localize) : null"
                        [attr.aria-label]="'FOOTER_FAQ_TEXT' | translate">
                        {{ 'FOOTER_FAQ_TEXT' | translate }}
                    </a>
                </li>

                <li class="footer__item" *ngIf="footerSupportActions.includes('report')">
                    <span class="icon icon-info"></span>
                    <a class="link--no-line" [routerLink]="'/customer-support/report' | localize">
                        {{ 'EMV_SUPPORT_LINK' | translate }}
                    </a>
                </li>
            </ul>
        </div>

        <div class="footer__about">
            <div class="footer__about-company">
                <div class="footer-landing-page-social-net">
                    <div class="footer-landing-page-social-net__name-registration">
                        <span class="footer-landing-page-social-net__name-company">
                            {{ 'FOOTER_COMPANY_NAME' | translate }}
                        </span>

                        <ng-container *ngIf="env.FOOTER.SOCIAL_LINKS">
                            <div class="footer-landing-page-social-net__name-dot"></div>
                            <span class="footer-landing-page-social-net__name-text">
                                {{ 'FOOTER_VISIT_US' | translate }}
                            </span>
                        </ng-container>
                    </div>
                </div>

                <ng-container *ngIf="env.FOOTER.SOCIAL_LINKS">
                    <div class="footer-landing-page-social-net-img big-icons">
                        <a
                            *ngIf="footerSocialLinks.includes('facebook')"
                            target="_blank"
                            href="{{ 'FOOTER_FACEBOOK_URL' | translate }}"
                            rel="noopener">
                            <img class="hide-for-wcag" alt="Facebook" src="{{ assetsPath$ | async }}/facebook.svg" />
                            <img
                                class="show-high-contrast-view"
                                alt="Facebook"
                                src="{{ assetsPath$ | async }}/facebook-wcag.svg" />
                        </a>

                        <a
                            *ngIf="footerSocialLinks.includes('instagram')"
                            target="_blank"
                            href="{{ 'FOOTER_INSTAGRAM_URL' | translate }}"
                            rel="noopener">
                            <img class="hide-for-wcag" alt="Instagram" src="{{ assetsPath$ | async }}/instagram.svg" />
                            <img
                                class="show-high-contrast-view"
                                alt="Instagram"
                                src="{{ assetsPath$ | async }}/instagram-wcag.svg" />
                        </a>

                        <a
                            *ngIf="footerSocialLinks.includes('linkedin')"
                            target="_blank"
                            href="{{ 'FOOTER_LINKEDIN_URL' | translate }}"
                            rel="noopener">
                            <img class="hide-for-wcag" alt="LinkedIn" src="{{ assetsPath$ | async }}/linkedin.svg" />
                            <img
                                class="show-high-contrast-view"
                                alt="LinkedIn"
                                src="{{ assetsPath$ | async }}/linkedin-wcag.svg" />
                        </a>
                    </div>
                </ng-container>
            </div>

            <div class="footer__about-terms">
                <a
                    class="link--no-line"
                    [routerLink]="'/terms-and-conditions' | localize"
                    routerLinkActive="router-link-active">
                    {{ 'TERMS' | translate }}
                </a>
            </div>
        </div>
    </footer>
</div>
